import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, withStyles, FormControl, TextField } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import PageTitle from '../../components/PageTitle/PageTitle';
import IconButton from '@material-ui/core/IconButton';
import * as Icons from '@material-ui/icons';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Swal from 'sweetalert2';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage, setSelectTenant } from '../../utils/common';
import CustomFooter from '../../components/Table/CustomFooter';
import SelectTenant from '../../components/Select/SelectTenant';

const noImageUrl = 'https://airpresense.s3-ap-southeast-1.amazonaws.com/images/no_img_gray.png';

class MapsManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant: 0,
    };
  }

  async componentDidMount() {
    const { offset, limit, search, sort, order, action, tenantIds } = this.props.maps.toJS();
    if (action) {
      this.setState({
        tenant: tenantIds && tenantIds.length > 0 ? JSON.stringify(tenantIds) : 0,
      });
      await this.props.maps.getMapList(offset, limit, search, sort, order, tenantIds);
      this.props.maps.setAction('action', null);
    } else {
      const tenantIds = localStorage.getItem('select_tenant') ? [+localStorage.getItem('select_tenant')] : null;
      this.setState({
        tenant: tenantIds ? JSON.stringify(tenantIds) : 0,
      });

      this.props.maps.resetData();
      await this.props.maps.setData('tenantIds', tenantIds);
      // await this.props.maps.getMapList();
    }
  }

  createMap() {
    const { classes, t } = this.props;
    return (
      <Button
        variant='outlined'
        color='primary'
        onClick={() => this.props.history.push('maps/create')}
        className={classes.button}
      >
        <Icons.Add />
        {t('create_map')}
      </Button>
    );
  }

  titleContent() {
    const { classes, t } = this.props;
    const { search } = this.props.maps.toJS();
    return (
      <div className={classes.titleBar}>
        <SelectTenant handleChangeTenant={this.handleChangeTenant} tenant={this.state.tenant} />
        <Grid className={classes.search}>
          <FormControl variant='outlined' className={classes.formControl} fullWidth>
            <TextField
              variant='outlined'
              size='small'
              value={search || ''}
              name='search'
              id='search'
              className={classes.contentInput}
              placeholder={t('search')}
              onChange={(e) => this.handleChangeSearch(e)}
            ></TextField>
          </FormControl>
        </Grid>
      </div>
    );
  }

  handleChangeSearch = (event) => {
    const { value } = event.target;
    this.props.maps.setData('offset', 0, false);
    this.props.maps.setData('search', value);
  };

  handleChangeTenant = async (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });

    const tenantIds = JSON.parse(value);
    await this.props.maps.setData('tenantIds', tenantIds);

    setSelectTenant(tenantIds);
  };

  deleteRouters(id) {
    const { t } = this.props;
    Swal.fire({
      html: `<h4>${t('remove_all_routers')}`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: `${t('remove')}`,
      cancelButtonText: `${t('cancel')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.router.deleteMaps(id);
          if (result.statusCode === 200) {
            Swal.fire({
              html: `<h4>${t('remove_success')}`,
              type: 'success',
            }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                const { offset, limit, search, sort, order, tenantIds } = this.props.maps.toJS();
                await this.props.maps.getMapList(offset, limit, search, sort, order, tenantIds);
              }
            });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_remove')}`, type: 'error' });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_remove')}`, type: 'error' });
          }
        }
      }
    });
  }

  deleteItem(id) {
    const { t } = this.props;
    Swal.fire({
      html: `<span class="swal-icon">
              <i
                class="fa fa-trash-o fa-3x fa-border"
                style="border: solid .08em #f27474; border-radius: 1.1em; margin-bottom: 35px; margin-top: 22px;">
              </i>
            </span>
            <br/>
            <h4>${t('delete_map')}`,
      showCancelButton: true,
      confirmButtonText: `${t('delete')}`,
      cancelButtonText: `${t('cancel')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.maps.deleteMaps(id);
          if (result.statusCode === 200) {
            Swal.fire({
              html: `<h4>${t('delete_success')}`,
              type: 'success',
            }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                const { offset, limit, search, sort, order, tenantIds } = this.props.maps.toJS();
                await this.props.maps.getMapList(offset, limit, search, sort, order, tenantIds);
              }
            });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        }
      }
    });
  }

  validateTableRow = (data, expectedSize) => {
    return data && Array.isArray(data) && data.length === expectedSize;
  };

  handleChangeRowsPerPage = (value) => {
    this.props.maps.setData('limit', value);
  };

  handlechangePage = (value) => {
    const { limit } = this.props.maps.toJS();
    this.props.maps.setData('offset', value * limit);
  };

  render() {
    const { classes, t } = this.props;
    const { maps, loading, limit, search } = this.props.maps.toJS();

    const page = maps.data ? maps.pagination.page - 1 : 0;
    const count = maps.data ? maps.pagination.count : 0;
    const ARRAYSIZE = 7;
    const columns = [
      {
        name: 'id',
        label: `${t('id')}`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'imgUrl',
        label: `${t('photo')}`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (_value, tableMeta) => {
            const row = tableMeta.rowData;
            const imgUrl = this.validateTableRow(row, ARRAYSIZE) ? row[1] : noImageUrl;
            return (
              <div className={classes.imgPreviewContainer}>
                <div
                  className={classNames(classes.imgPreview, classes.rounded)}
                  style={{
                    background: `url("${imgUrl || noImageUrl}") center no-repeat`,
                  }}
                />
              </div>
            );
          },
        },
      },
      {
        name: 'name',
        label: `${t('name')}`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[2]}</div>;
          },
        },
      },
      {
        name: 'tenant.name',
        label: `${t('tenant')}`,
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[3]}</div>;
          },
        },
      },
      {
        name: 'location.name',
        label: `${t('location')}`,
        options: {
          filter: true,
          sort: true,
          display: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[4]}</div>;
          },
        },
      },
      {
        name: 'totalRouter',
        label: `${t('no_of_routers')}`,
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[5]}</div>;
          },
        },
      },
      {
        name: '',
        label: `${t('action')}`,
        options: {
          filter: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div className={classes.actionBox}>
                <Link to={`/app/maps/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/manage`}>
                  <Button variant='outlined' color='primary' className={classes.button}>
                    {t('manage_router')}
                  </Button>
                </Link>
                <Link to={`/app/maps/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/view`}>
                  <IconButton title={t('view')}>
                    <Icons.FormatListBulleted color='primary' />
                  </IconButton>
                </Link>
                <Link to={`/app/maps/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/edit`} title={t('edit')}>
                  <IconButton>
                    {' '}
                    <Icons.Edit color='primary' />
                  </IconButton>
                </Link>
                <IconButton
                  disabled={this.validateTableRow(row, ARRAYSIZE) && row[5] ? false : true}
                  title={t('unassign')}
                  onClick={() => this.deleteRouters(this.validateTableRow(row, ARRAYSIZE) ? row[0] : '')}
                >
                  <Icons.LinkOff color={this.validateTableRow(row, ARRAYSIZE) && row[5] ? 'primary' : 'disabled'} />
                </IconButton>
                <IconButton
                  disabled={this.validateTableRow(row, ARRAYSIZE) && row[5] ? true : false}
                  title={t('delete')}
                  onClick={() => this.deleteItem(this.validateTableRow(row, ARRAYSIZE) ? row[0] : '')}
                >
                  <Icons.Delete color={this.validateTableRow(row, ARRAYSIZE) && row[5] ? 'disabled' : 'primary'} />
                </IconButton>
              </div>
            );
          },
        },
      },
    ];

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <PageTitle title={t('all_map')} button={this.createMap()}>
          {this.titleContent()}
        </PageTitle>
        <Grid className={classes.mainContain} container spacing={32}>
          <Grid item xs={12}>
            <MUIDataTable
              data={maps.data}
              columns={columns}
              options={{
                count: maps.data ? maps.pagination.count : 0,
                page: maps.data ? maps.pagination.page - 1 : 0,
                searchText: search,
                serverSide: true,
                pagination: true,
                onTableChange: (action, tableState) => {
                  // console.log(action, tableState);
                  switch (action) {
                    case 'changePage':
                      this.props.maps.setData('offset', tableState.page * tableState.rowsPerPage);
                      // this.props.user.setData('page',tableState.page);
                      break;
                    case 'changeRowsPerPage':
                      this.props.maps.setData('limit', tableState.rowsPerPage);
                      break;
                    case 'search':
                      this.props.maps.setData('offset', 0, false);
                      this.props.maps.setData('search', tableState.searchText);
                      break;
                    case 'sort':
                      const sortList = tableState.announceText.split(' ');
                      this.props.maps.setData('offset', 0, false);
                      this.props.maps.setData('sort', sortList[4], false);
                      this.props.maps.setData('order', sortList[6] === 'descending' ? 'desc' : 'asc');
                      break;
                    default:
                      break;
                  }
                },
                print: false,
                download: false,
                viewColumns: false,
                search: false,
                sortFilterList: true,
                sort: true,
                selectableRows: 'none',
                selectableRowsOnClick: false,
                filter: false,
                filterType: 'dropdown',
                responsive: 'scrollFullHeight',
                rowsPerPageOptions: [10, 15, 50],
                rowsPerPage: limit,
                customFooter: (rowsPerPage, changeRowsPerPage, changePage, textLabels) => {
                  return (
                    <CustomFooter
                      count={count}
                      page={page}
                      rowsPerPage={limit}
                      changeRowsPerPage={this.handleChangeRowsPerPage}
                      changePage={this.handlechangePage}
                      textLabels={textLabels}
                      rowsPerPageOptions={[10, 15, 50]}
                    />
                  );
                },
              }}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  imgPreviewContainer: {
    minWidth: '100px',
    width: '100%',
    position: 'relative',
  },
  imgPreview: {
    backgroundSize: 'contain !important',
    height: '100px',
    border: '1px solid #ced4da',
  },
  button: {
    height: '38px',
    margin: theme.spacing.unit / 2,
  },
  actionBox: {
    minWidth: '350px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
    marginLeft: theme.spacing.unit * 2,
  },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  search: {
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
    },
  },
});

export const page = inject('locations', 'router', 'maps')(observer(MapsManager));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
